<mat-card-header>
	<mat-card-title #searchChildCommunicationEventsElement class="scroll-margin">
		{{title}}
		<mat-icon *ngIf="isLoading">
			<mat-spinner diameter="20"> </mat-spinner>
		</mat-icon>
	</mat-card-title>
</mat-card-header>

<div *ngIf="results.length === 0 && !isLoading">
	<hr />
	<h2 class="text-center"> 
		{{getStudentName(student) + ' does not have any Communication Events.'}}
	</h2>
</div>

<mat-card-content>
	<div *ngIf="!isLoading && regions && regions.length > 0">

		<div *ngFor="let region of regions; let i = index" class="margin-top-md">
			<h3>Region {{region.CODE}} - {{region.NAME}}</h3>

			<div class="table-responsive">
				<mat-table [dataSource]="region.tableDataSource" class="mat-elevation-z1" matSort>
					<!-- <ng-container matColumnDef="SEARCH">
					<mat-header-cell *matHeaderCellDef> </mat-header-cell>
					<mat-cell *matCellDef="let element">
						<div>
							<get-student-with-same-communication-event-btn [studentCommunicationEvent]="element"
								(onConfirm)="getStudentsWithSameCommunicationEvent($event)"></get-student-with-same-communication-event-btn>
						</div>
					</mat-cell>
				</ng-container> -->

					<ng-container matColumnDef="CREATED_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Created </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div class="row">
								<div class="icon-text">
									<mat-icon>person</mat-icon> <span class="margin-xs">{{element.CREATED_BY}}</span>
								</div>
								<div class="icon-text">
									<mat-icon>schedule</mat-icon> <span class="margin-xs">{{element.CREATED_DATE |
										simpleDate}}</span>
								</div>
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="MODIFIED_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Updated </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div class="row" *ngIf="element.MODIFIED_BY">
								<div class="icon-text">
									<mat-icon>person</mat-icon> <span class="margin-xs">{{element.MODIFIED_BY}}</span>
								</div>
								<div class="icon-text">
									<mat-icon>schedule</mat-icon> <span class="margin-xs">{{element.MODIFIED_DATE |
										simpleDate}}</span>
								</div>
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="COMMUNICATION_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Communication Date </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.COMMUNICATION_DATE | simpleDate}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="COMMUNICATION_EVENT_PURPOSE_TYPES.TYPE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Purpose </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.COMMUNICATION_EVENT_PURPOSE_TYPES.TYPE}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="COMMENTS">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Comments </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div class="row">
								<div>
									{{element.COMMENTS}}</div>
								<div>
									<hr>
								</div>
								<div class="icon-text">
									<mat-checkbox disabled="true" [color]="'primary'" class="checkbox-margin"
										[checked]="element.STUDENT_COMMUNICATION_EVENT_PROPERTIES.length > 0">
									</mat-checkbox>
									{{getPropertyPipe.transform(communicationEventPurposeTypes[0],
									'COMMUNICATION_EVENT_PURPOSE_PROPERTIES[0].COMMUNICATION_EVENT_PURPOSE_PROPERTY_TYPES.DESCRIPTION',
									false, true)}}
								</div>
							</div>
						</mat-cell>
					</ng-container>

					<mat-header-row *matHeaderRowDef="studentCommunicationEventColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: studentCommunicationEventColumns;"></mat-row>
				</mat-table>
			</div>

			<mat-paginator #paginators
				[pageSizeOptions]="[5, 10, 20, (region.tableDataSource ? region.tableDataSource.data.length > 100 ? region.tableDataSource.data.length : 100 : 100 )]"
				showFirstLastButtons aria-label="Select page of periodic elements"
				[hidden]="region.tableDataSource?.filteredData?.length === 0">
			</mat-paginator>
		</div>

	</div>

	<div #matchingCommunicationEventsElement class="scroll-margin">

		<hr />
		<mat-card-title *ngIf="isSearchedLoading">
			Matching Communication Events
			<mat-icon>
				<mat-spinner diameter="20"> </mat-spinner>
			</mat-icon>
		</mat-card-title>
		<mat-card-title *ngIf="!isSearchedLoading && searchedRegions && searchedRegions.length > 0">
			{{searchedResults.length}} matching Communication Events found

			<span class="pull-right">
				<button mat-raised-button color="warn" (click)="removeAllSearchedResults()"
					*ngIf="searchedSelectCount > 0">Clear Selected Children</button>
				<button mat-raised-button color="primary" (click)="selectAllSearchedResults()">Selected All
					Children</button>
			</span>
		</mat-card-title>
		<mat-card-subtitle *ngIf="!isSearchedLoading && searchedRegions && searchedRegions.length > 0">
			<span *ngFor="let filter of searchedFilters | keyvalue | orderBy: 'value.index'">
				<mat-checkbox [disabled]="true" [color]="'primary'" class="checkbox-margin"
					[checked]="filter.value.checked">
				</mat-checkbox>
				{{filter.key}}
			</span>
		</mat-card-subtitle>
	</div>

	<div *ngIf="!isSearchedLoading && searchedRegions && searchedRegions.length > 0">

		<div *ngFor="let region of searchedRegions; let i = index" class="margin-top-md">
			<h3>Region {{region.CODE}} - {{region.NAME}}</h3>

			<div class="table-responsive">
				<mat-table [dataSource]="region.tableDataSource" class="mat-elevation-z1" matSort>
					<ng-container matColumnDef="EDIT">
						<mat-header-cell *matHeaderCellDef> </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								<button mat-icon-button [color]="!element.SELECTED ? 'primary' : 'warn'"
									(click)="toggleSearchedResult(element)">
									<mat-icon [matTooltip]="'Add Child'" [matTooltipPosition]="'above'"
										*ngIf="!element.SELECTED">add</mat-icon>
									<mat-icon [matTooltip]="'Remove Child'" [matTooltipPosition]="'above'"
										*ngIf="element.SELECTED">remove</mat-icon>
								</button>
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="STUDENT.MSD_NUMBER">
						<mat-header-cell *matHeaderCellDef mat-sort-header> MSD Number </mat-header-cell>
						<mat-cell *matCellDef="let element">
							{{element.STUDENT.MSD_NUMBER}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="STUDENT.PERSON.LAST_NAME">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.STUDENT.PERSON.LAST_NAME |
							titlecase}}{{(element.STUDENT.SECOND_LAST_NAME
							? ' ' + element.STUDENT.SECOND_LAST_NAME + ',': ',') | titlecase}}
							{{element.STUDENT.PERSON.FIRST_NAME |
							titlecase}}
							{{element.STUDENT.PERSON.MIDDLE_INITIAL | titlecase}}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="CREATED_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Created </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div class="row">
								<div class="icon-text">
									<mat-icon>person</mat-icon> <span class="margin-xs">{{element.CREATED_BY}}</span>
								</div>
								<div class="icon-text">
									<mat-icon>schedule</mat-icon> <span class="margin-xs">{{element.CREATED_DATE |
										simpleDate}}</span>
								</div>
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="MODIFIED_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Updated </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div class="row" *ngIf="element.MODIFIED_BY">
								<div class="icon-text">
									<mat-icon>person</mat-icon> <span class="margin-xs">{{element.MODIFIED_BY}}</span>
								</div>
								<div class="icon-text">
									<mat-icon>schedule</mat-icon> <span class="margin-xs">{{element.MODIFIED_DATE |
										simpleDate}}</span>
								</div>
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="COMMUNICATION_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Communication Date </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.COMMUNICATION_DATE | simpleDate}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="COMMUNICATION_EVENT_PURPOSE_TYPES.TYPE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Purpose </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.COMMUNICATION_EVENT_PURPOSE_TYPES.TYPE}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="COMMENTS">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Comments </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div class="row">
								<div>
									{{element.COMMENTS}}</div>
								<div>
									<hr>
								</div>
								<div class="icon-text">
									<mat-checkbox disabled="true" [color]="'primary'" class="checkbox-margin"
										[checked]="element.STUDENT_COMMUNICATION_EVENT_PROPERTIES.length > 0">
									</mat-checkbox>
									{{getPropertyPipe.transform(communicationEventPurposeTypes[0],
									'COMMUNICATION_EVENT_PURPOSE_PROPERTIES[0].COMMUNICATION_EVENT_PURPOSE_PROPERTY_TYPES.DESCRIPTION',
									false, true)}}
								</div>
							</div>
						</mat-cell>
					</ng-container>

					<mat-header-row *matHeaderRowDef="searchedStudentCommunicationEventColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: searchedStudentCommunicationEventColumns;"></mat-row>
				</mat-table>
			</div>

			<mat-paginator #paginators
				[pageSizeOptions]="[5, 10, 20, (region.tableDataSource ? region.tableDataSource.data.length > 100 ? region.tableDataSource.data.length : 100 : 100 )]"
				showFirstLastButtons aria-label="Select page of periodic elements"
				[hidden]="region.tableDataSource?.filteredData?.length === 0">
			</mat-paginator>
		</div>

	</div>

	<div *ngIf="searchedSelectCount > 0" #actionCommunicationEventsElement class="scroll-margin">
		<hr />
		<div class="row">
			<div class="col-lg-6">
				<div class="row">
					<button type="button" color="primary" mat-raised-button (click)="setMode('create')"
						*ngIf="mode === ''">
						Create Communication Event for {{searchedSelectCount}} child{{searchedSelectCount > 1 ? 'ren' :
						''}}
					</button>
				</div>
			</div>
			<div class="col-lg-6">
				<div class="row">
					<button type="button" color="primary" mat-raised-button (click)="setMode('update')"
						*ngIf="mode === ''">
						Update Communication Event for {{searchedSelectCount}} child{{searchedSelectCount > 1 ? 'ren' :
						''}}
					</button>

					<confirm-popover *ngIf="mode === ''" class="margin-bottom-xs btn-fill-width" [buttonType]="'string'"
						[color]="'warn'"
						[popoverMsg]="'Confirm to delete ' + searchedSelectCount.toString() + ' Communication Event'"
						[popoverConfirmText]="'Delete'"
						[buttonTxt]="'Delete ' + searchedSelectCount.toString() + ' Communication Event' + (searchedSelectCount > 1 ? 's' : '')"
						[popoverConfirmColor]="'warn'" (onConfirm)="deleteSelectedStudentCommunicationEvents()"
						[disabled]="isDeleting">
					</confirm-popover>
				</div>
			</div>
		</div>
		<div>
			<div *ngIf="mode === 'create'">
				<create-edit-communication-events [students]="searchedShoppingCartStudents"
					(returnOutput)="createCommunicationEventsOutput($event)"></create-edit-communication-events>
			</div>
			<div *ngIf="mode === 'update'">
				<create-edit-communication-events [studentCommunicationEvents]="searchedShoppingCart"
					(returnOutput)="editCommunicationEventsOutput($event)"></create-edit-communication-events>
			</div>
		</div>
	</div>

</mat-card-content>